export default __webpack_public_path__ + "b9a2d6c7b5850dd2d72c4aded2ee8eba.png";